// @ts-nocheck
import { Shaders } from '../../../build/shaders/shaders';

const originalRender = Potree.Renderer.prototype.render;
const originalRenderOctree = Potree.Renderer.prototype.renderOctree;

export const renderMixin = {
    renderOctree(octree, nodes, camera, target, params = {}) {
        const material = params.material ? params.material : octree.material;

        if (this.shaders.has(material)) {
            let vs = Shaders['pointcloud-psp.vs'];
            // let vs = material.vertexShader;
            const fs = material.fragmentShader;

            // Replacing the vertex shader with ours, so need to make sure the defines are included
            const definesString = material.getDefines();

            const vsVersionIndex = vs.indexOf('#version ');

            if (vsVersionIndex >= 0) {
                vs = vs.replace(/(#version .*)/, `$1\n${definesString}`);
            } else {
                vs = `${definesString}\n${vs}`;
            }

            this.shaders.get(material)?.update(vs, fs);
            material.vertexShader = vs;
            material.fragmentShader = fs;
        }
        return originalRenderOctree.call(this, octree, nodes, camera, target, params);
    },

    render(scene, camera, target = null, params = {}) {
        // Get traversal result (copied from original render method)
        const traversalResult = this.traverse(scene);

        // For each octree
        for (const octree of traversalResult.octrees) {
            const material = octree.material;

            // Get shader
            const shader = this.shaders.get(material);

            if (shader) {
                this.gl.useProgram(shader.program);

                const clipboxFlagsLocation = shader.uniformLocations['clipBoxFlags[0]'];
                if (clipboxFlagsLocation) {
                    shader.gl.uniform1iv(clipboxFlagsLocation, material.uniforms.clipBoxFlags.value);
                }
                const clipPolygonFlagsLocation = shader.uniformLocations['clipPolygonFlags[0]'];
                if (clipPolygonFlagsLocation) {
                    shader.gl.uniform1iv(clipPolygonFlagsLocation, material.uniforms.clipPolygonFlags.value);
                }
                const isClipVolumeToolLocation = shader.uniformLocations['isClipVolumeTool'];
                if (isClipVolumeToolLocation) {
                    const isClipVolumeTool = material.uniforms.isClipVolumeTool;
                    if (isClipVolumeTool != null && typeof isClipVolumeTool != 'undefined') {
                        shader.setUniform('isClipVolumeTool', material.uniforms.isClipVolumeTool.value);
                    }
                }
                const highlightTintLocation = shader.uniformLocations['highlightTint'];
                if (highlightTintLocation) {
                    const tint = material.uniforms.highlightTint?.value;
                    if (tint) {
                        shader.gl.uniform3f(highlightTintLocation, tint.x, tint.y, tint.z);
                    }
                }
                const stepColoursLocation =
                    shader.uniformLocations['deformationStepColours[0]'] ||
                    shader.uniformLocations['deformationStepColours'];
                if (stepColoursLocation && material.uniforms.deformationStepColours?.value) {
                    const deformationStepColours = material.uniforms.deformationStepColours.value;

                    try {
                        // Ensure it's a flat Float32Array
                        const flatArray = new Float32Array(deformationStepColours);
                        shader.gl.uniform3fv(stepColoursLocation, flatArray);
                    } catch (error) {
                        console.error('Error setting deformationStepColours uniform:', error);
                    }
                }

                const deformationStepsLocation =
                    shader.uniformLocations['deformationSteps[0]'] || shader.uniformLocations['deformationSteps'];
                if (deformationStepsLocation && material.uniforms.deformationSteps?.value) {
                    const deformationSteps = material.uniforms.deformationSteps.value;

                    try {
                        // Ensure it's a flat Float32Array
                        const flatArray = new Float32Array(deformationSteps);
                        shader.gl.uniform2fv(deformationStepsLocation, flatArray);
                    } catch (error) {
                        console.error('Error setting deformationSteps uniform:', error);
                    }
                }
            }
        }

        // Call original render method
        return originalRender.call(this, scene, camera, target, params);
    },
};
